import React from "react";
import GameHostingHero from "../components/game-hosting/GameHostingHero";
import GameHostingHighlights from "../components/game-hosting/GameHostingHighlights";
import GameHostingPlans from "../components/sections/PricingCalculator";
import SupportedGames from "../components/game-hosting/SupportedGames";
import HowItWorks from "../components/game-hosting/HowItWorks";
import GameHostingFAQ from "../components/game-hosting/GameHostingFAQ";
import GameHostingCTA from "../components/game-hosting/GameHostingCTA";

export default function GameHostingPage() {
    return (
        <>
            <GameHostingHero />
            <GameHostingHighlights />
            <GameHostingPlans />
            <SupportedGames />
            <HowItWorks />
            <GameHostingFAQ />
            <GameHostingCTA />
        </>
    );
}
